export default __webpack_public_path__ + "static/media/cannot-deal.719a6f61.ogg";